import {getCategoriesOrderedTree, getCategorisedObjectsTree, getMappedTree} from './tree';

export const DCS_ORDERED_TREE_ROOT = {
  CatCode: 'DCS',
  labels: {
    en: 'Default Category Scheme', /* TODO: translatable */
    it: 'Category Scheme di Lavoro'
  }
};

export function getCubesTree(cubesJson, dcsJson) {
  return getCategorisedObjectsTree(
    cubesJson,
    [{
      ...DCS_ORDERED_TREE_ROOT,
      children:
        getCategoriesOrderedTree(
          dcsJson,
          'children',
          (cat, anch) => anch ? (cat.ParCode === anch.CatCode) : (cat.ParCode !== null),
          (a, b) => (a.Code || -1) - (b.Code || -1) || a.CatCode - b.CatCode
        )
    }],
    'children',
    (a, b) => a.Code - b.Code,
    (obj, cat) => cat ? (obj.IDCat === cat.IDCat) : (obj.IDCat !== null),
    'CatCode',
    'labels',
    true
  );
}

export function getSortedCubesTree(categorisedCubes) {
  return getMappedTree(
    categorisedCubes,
    "children",
    node => {
      let ordCount = 1;
      return {
        ...node,
        children: node.children
          ? node.children
            .sort((a, b) => {
              if (a.Ord !== undefined && b.Ord !== undefined) {
                return a.Ord - b.Ord;
              } else if (a.Ord !== undefined) {
                return a;
              } else if (b.Ord !== undefined) {
                return b;
              } else {
                return (a.CatCode || -1) - (b.CatCode || -1);
              }
            })
            .map(c => ({
              ...c,
              Ord: c.Ord !== undefined ? String(ordCount++) : undefined
            }))
          : node.children
      }
    }
  );
}

